import Icon from '../components/Icon.vue'

Icon.register({
  'video-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1c7 5.4 8.3 15.5 2.8 22.4l-19.6 25.3c-5.5 7-15.5 8.2-22.5 2.8l-178.5-138-373.3-288.6-36.5-28.2c-7-5.4-8.2-15.4-2.8-22.4l19.6-25.2c5.5-7 15.5-8.2 22.5-2.8l78.4 60.6h244.3c26.4 0 47.8 21.4 47.8 47.8v178l32 24.7v-137.2l109.6-75.6c21.3-14.6 50.4 0.3 50.4 25.8v257c0 17.4-13.8 29.7-29.2 31.1zM32 400.2v-245.5l365.8 282.8c-8.2 6.5-18.4 10.5-29.6 10.5h-288.4c-26.4 0-47.8-21.4-47.8-47.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/video-slash.js
// module id = 2090
// module chunks = 0